(function() {
  const announcementBar = document.querySelector('.announcement-bar-section');
  const headerSticky = document.querySelector('.shopify-section-header-sticky');

  if (!announcementBar || !headerSticky) return;

  announcementBar.style.position = 'sticky';
  announcementBar.style.top = '0';
  headerSticky.style.top = `${announcementBar.offsetHeight - 0.5}px`;

  window.addEventListener('resize', () => {
    headerSticky.style.top = `${announcementBar.offsetHeight - 0.5}px`;
  });
})();
